export default __webpack_public_path__ + "static/brian-terlson-ed1d6c21025f09787248bc512fe38939.jpg";